import { createContext, useCallback, useContext, useEffect, useState } from "react";
import organizationsService from "services/organizations";
import { IOrganization } from "types/organizations";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/Auth";

type OrganizationContextType = {
  organization: IOrganization | null;
  setOrganization: (organization: IOrganization | null) => void;
  saveOrganization: () => Promise<void>;
  loading: boolean;
  error: string | undefined;
  setLoading: (loading: boolean) => void;
  setError: (error: string | undefined) => void;
  fetchOrganization: () => void;
};

export const OrganizationContext = createContext<OrganizationContextType>({
  saveOrganization: async () => { },
  organization: null,
  setOrganization: () => { },
  loading: false,
  error: undefined,
  setLoading: () => { },
  setError: () => { },
  fetchOrganization: () => { },
});

export const OrganizationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [organization, setOrganization] = useState<IOrganization | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const saveOrganization = async () => {
    try {
      console.log('saveOrganization', organization);
      setLoading(true);
      if (!organization?.name) {
        throw new Error("Please fill in all required fields");
      }
      await organizationsService.update(organization.id, organization);
      navigate('/');
    } catch (error: any) {
      console.error("Error saving organization:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchOrganization = useCallback(async () => {
    setLoading(true);
    try {
      const organizationId = user?.currentOrganization?.id || user?.currentOrganization?._id || user?.currentOrganization?.organizationId;
      console.log('organizationId', organizationId);
      const response = await organizationsService.fetch(organizationId);
      console.log('response', response);
      setOrganization(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchOrganization();
    console.log('organization', organization);
  }, [user]);

  return (
    <OrganizationContext.Provider value={{ saveOrganization, organization, setOrganization, loading, error, setLoading, setError, fetchOrganization }}>
      {children}
    </OrganizationContext.Provider>
  );
};

export const useOrganization = () => {
  const context = useContext(OrganizationContext);
  if (!context) {
    throw new Error('useOrganization must be used within an OrganizationProvider');
  }
  return context;
};